import * as z from "zod";

const aggregateArm = z.object({
  arm: z.enum(["imessage", "sms_forced"]),
  enrolledCustomers: z.number(),
  dispatchesSent: z.number(),
  /** Dispatch-time routing decision, not confirmed handset delivery. */
  dispatchesViaImessage: z.number(),
  dispatchesViaSms: z.number(),
  customersWithReply: z.number(),
  replyCount: z.number(),
});

const significance = z.object({
  pValue: z.number(),
  percentageImprovement: z.number().nullable(),
  improvementDirection: z.enum(["better", "worse", "comparable"]),
  significant: z.boolean(),
});

/** Pooled across every active iMessage channel test, all teams. No input. */
export const getImessageChannelExperimentAggregate = {
  name: "getImessageChannelExperimentAggregate" as const,
  input: z.object({}),
  output: z.object({
    testCount: z.number(),
    teamCount: z.number(),
    imessage: aggregateArm,
    smsForced: aggregateArm,
    /** Null when either arm has zero enrolled customers. */
    significance: significance.nullable(),
  }),
};
